import api from './api';
export default {
    postActivity (parms) {
      return api.post('activity', parms)
    },
  }
  